"use client";
import Breadcrumb from "./Breadcrumb";
import MobileMenu from "./MobileMenu";
import Footer1 from "./footer/Footer1";

import BackToTop from "@components/elements/BackToTop";
import DataBg from "@components/elements/DataBg";
import SvgIcon from "@components/elements/SvgIcon";
import { useEffect, useState } from "react";
import Header2 from "./header/Header2";
import Header5 from "./header/Header5";
const Layout = ({
  headerStyle,
  footerStyle,
  children,
  headerBg,
  breadcrumbTitle,
  breadcrumbSubTitle,
  breadcrumbAlign,
  pages,
  imageBg = {} 
}) => {
  const [isToggled, setToggled] = useState(false);
  const handleToggle = () => setToggled(!isToggled);

  const [scroll, setScroll] = useState(0);
  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > 100;
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck);
      }
    });
  });

  return (
    <>
      <DataBg />
      <SvgIcon />
      {!headerStyle && (
        <Header2
          isToggled={isToggled}
          handleToggle={handleToggle}
          scroll={scroll}
          pagesHeader={pages}
        />
      )}
      {headerStyle === 2 && (
        <Header2
          isToggled={isToggled}
          handleToggle={handleToggle}
          scroll={scroll}
          pagesHeader={pages}
        />
      )}
      {headerStyle === 5 && (
        <Header5
          isToggled={isToggled}
          handleToggle={handleToggle}
          scroll={scroll}
          pagesHeader={pages}
        />
      )}
      <MobileMenu isToggled={isToggled} handleToggle={handleToggle}  pagesHeader={pages} />
      {breadcrumbTitle && (
        <Breadcrumb
          breadcrumbTitle={breadcrumbTitle}
          breadcrumbSubTitle={breadcrumbSubTitle}
          breadcrumbAlign={breadcrumbAlign}
          image={imageBg}
        />
      )}  
      {children}
      <Footer1 pagesFooter={pages} />

      <BackToTop scroll={scroll} />
    </>
  );
};

export default Layout;
